import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { translations } from "../translations";

const unlockBordersImg = "/assets/unlock-borders.webp";

const StyledCTASection = styled(Box)(({ theme }) => ({
  background: "var(--overlay-light)",
  borderRadius: "40px",
  position: "relative",
  overflow: "hidden",
  height: "650px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  padding: theme.spacing(10),
  [theme.breakpoints.down("md")]: {
    height: "500px",
  },
}));

const CTATitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h1,
  color: "var(--text-white)",
  textAlign: "center",
  maxWidth: "907px",
  lineHeight: "normal",
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
  },
}));

const CTASubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: "var(--text-white)",
  textAlign: "center",
  maxWidth: "503px",
  lineHeight: "normal",
}));

const CTAButton = styled(Button)(({ theme }) => ({
  background: "var(--background-white)",
  color: "var(--text-black)",
  borderRadius: "100px",
  padding: "16px 24px",
  ...theme.typography.body1,
  textTransform: "none",
  gap: "8px",
  "&:hover": {
    background: "var(--overlay-white)",
  },
}));

export default function CTASection() {
  const t = translations;

  return (
    <StyledCTASection
      style={{
        backgroundImage: `linear-gradient(var(--overlay-dark), var(--overlay-dark)), url(${unlockBordersImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <CTATitle>{t.unlockBorders}</CTATitle>
      <CTASubtitle>{t.ctaSubtitle}</CTASubtitle>
      <CTAButton
        onClick={() => window.open("https://uat.gtcpay.io", "_blank")}
      >
        {t.getYourWallet}
      </CTAButton>
    </StyledCTASection>
  );
}
